import { render, staticRenderFns } from "./Cgc.vue?vue&type=template&id=d39f6342&"
import script from "./Cgc.vue?vue&type=script&lang=js&"
export * from "./Cgc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports